import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLetterCase',
    standalone: true
})
export class FirstLetterCasePipe implements PipeTransform {

  transform(value: string): any {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

}
